// © Microsoft Corporation. All rights reserved.
/**
 * Gets if the current page should be considered as a China compliance context.
 * @param pageUrl - The current page URL info with the following info:
 *  - hostname: The hostname of the current page URL.
 *  - search: The search part of the current page URL.
 * @param clientSettings - The client settings of the page.
 * @returns `true` if the current page should be considered as a China compliance context; otherwise, `false`.
 */
export function isChinaCompliance(pageUrl, clientSettings) {
    const isChina = pageUrl.hostname.toLowerCase().endsWith(".cn")
        // PCS sends isChinaCompliance to be true when it meets appropriate conditions.
        // This flag is not present or will be undefined when PCS conditions aren't met.
        || clientSettings.isChinaCompliance
        // Widget Initializer set this flag when host page ask to use China domain
        || clientSettings.useCnDomain
        // Sapphire mini app sets this flag to true or false based on app configuration
        || pageUrl.search.match(/isChinaBuild=true/i)
        // For testing/debugging on localhost, item=revip:cn
        || pageUrl.search.match(/item=revip:cn/);
    return !!isChina;
}
//# sourceMappingURL=ChinaCompliance.js.map